/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelWwwControl.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/www-control";

export class AutogenModelWwwControl<RowType extends ModelRow> extends Endpoint<RowType, RowWwwControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowWwwControl extends ModelRow<RowWwwControlFields> {
	constructor(values?: Partial<RowWwwControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowWwwControlFields {
	accept_order: string;
	adv_bill_of_lading_required: string;
	adv_delivery_receipt_req: string;
	adv_invoice_required: string;
	adv_other_required: string;
	adv_paperwork_req: string;
	adv_receipt_required: string;
	adv_toll_ticket_required: string;
	adv_weight_receipt_required: string;
	advance_conf: string;
	advance_eligible: string;
	advance_memo: string;
	advance_request_notify_user: string;
	advance_wire_code: string;
	allow_carrier_call: string;
	allow_carrier_dsp: string;
	allow_driver_rec: string;
	allow_location_order_entry: string;
	allow_service_fail: string;
	app_status: string;
	assistance_contact: string;
	asuser: string;
	avail_tract_path: string;
	avail_tract_sample: string;
	book_truckload_quote_when: string;
	breadcrumb_interval: number;
	broadcast_msg: string;
	canadian_drapp: string;
	carr_contact_email: string;
	carr_contact_fax: string;
	carr_contact_phone: string;
	carr_notify_email: string;
	company_email: string;
	company_id: string;
	company_phone: string;
	configure_url: string;
	contact_name: string;
	customer_ftl_emails: string;
	customer_ltl_emails: string;
	decline_offer: string;
	default_admin_user: string;
	dispatcher_advance_notify: string;
	dispatcher_lateeta: string;
	dispatcher_quick_pay_notify: string;
	display_broker_callins: string;
	display_eta: string;
	display_reefer_temp: string;
	display_unpaid_holds: string;
	display_ysplit_stops: string;
	dr_contact_email: string;
	dr_contact_name: string;
	dr_contact_phone: string;
	dr_email_list: string;
	dr_history: number;
	dr_response: string;
	driver_recruiting: string;
	earliest_pickup: Date;
	enable_avail_tract: string;
	enable_equipment_pref: string;
	enable_lane_pref: string;
	enable_raterequest: string;
	factor_company_search_days: number;
	factoring_company_emails: string;
	fax_enable: string;
	fileimport_profile: string;
	footer_file: string;
	ftl_order_type_id: string;
	google_api_key_web: string;
	header_bg: string;
	header_bg_color: string;
	header_bg_name: string;
	header_file: string;
	header_height: number;
	header_hor_align: string;
	header_logo: string;
	header_logo_name: string;
	home_page_msg: string;
	id: number;
	im_comment_type: string;
	image_zoom: number;
	imaging_enable: string;
	img_category: string;
	img_contact_email: string;
	img_contact_name: string;
	img_contact_phone: string;
	img_ftpport: string;
	img_host: string;
	img_password: string;
	img_port: string;
	img_username: string;
	inactivity_limit: number;
	incl_only_brokered: string;
	incl_only_loadbrd: string;
	include_holiday: string;
	include_rate_info: string;
	include_saturday: string;
	include_sunday: string;
	include_tracking_callins: string;
	legal_terms: string;
	legal_terms_name: string;
	loadboard_active: string;
	loadboard_show_b4_search: string;
	lock_account_days: number;
	ltl_max_days_out: number;
	ltl_max_weight: number;
	ltl_max_weight_um: string;
	ltl_order_type_id: string;
	ltl_quote_sheet_template: number;
	make_offer: string;
	max_failed_logins: number;
	min_password_length: number;
	notify_customer_salesman: string;
	notify_dispatcher: string;
	notify_ops_user: string;
	notify_template: number;
	ops_user_late_eta: string;
	ops_users_advance_notify: string;
	ops_users_quick_pay_notify: string;
	ord_confirm_msg: string;
	ord_contact_email: string;
	ord_contact_name: string;
	ord_contact_phone: string;
	ord_density_warning: string;
	ord_email_list: string;
	ord_latest_pickup_time: Date;
	ord_pickup_window_minutes: number;
	ord_prep_time_minutes: number;
	ord_submit_ok: string;
	ord_welcome_msg: string;
	password_numeric_char: number;
	password_reset_expiration: number;
	password_special_char: number;
	password_upper_char: number;
	pending_booking_message: string;
	position_rpt: string;
	prev_search_days: number;
	promote_web_site: string;
	qp_bill_of_lading_required: string;
	qp_delivery_receipt_req: string;
	qp_invoice_required: string;
	qp_other_required: string;
	qp_receipt_required: string;
	qp_toll_ticket_required: string;
	qp_weight_receipt_required: string;
	qualcom_enable: string;
	quick_pay_conf: string;
	quick_pay_eligible: string;
	quick_pay_memo: string;
	quickpay_paper_req: string;
	quickpay_request_notify_usr: string;
	rate_request_no: string;
	rate_request_ok: string;
	rate_request_text: string;
	rate_request_user: string;
	record_source: string;
	reminder_dow: string;
	reminder_time: Date;
	require_legal_term: string;
	require_order_term: string;
	session_timeout: number;
	settle_from_img: string;
	showas_location_enable: string;
	slogan: string;
	suppress_felony: string;
	text_color: string;
	tracking_email: string;
	unauth_max_searches: number;
	unauth_search_timeout: number;
	unauth_tracking_enabled: string;
	user_group_agent: string;
	user_group_carrier: string;
	user_group_customer: string;
	user_group_driver: string;
	user_group_location: string;
	web_address: string;
}

